module.exports = __webpack_public_path__ + "static/img/1531.92b0272.png";